module.exports = __webpack_public_path__ + "static/media/angieG80-2.c43197f9.jpg";